var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.355927 0.0456936C0.296868 0.0778059 0.206151 0.164395 0.154382 0.238157C0.102579 0.311918 0.0426757 0.450283 0.0212288 0.545607C-0.00754307 0.673761 -0.00712054 0.769592 0.0228135 0.912936C0.0556353 1.06987 0.593673 1.9542 2.84302 5.54816L5.62266 9.98945L2.84302 14.4307C0.593673 18.0247 0.0556353 18.909 0.0228135 19.066C-0.00712054 19.2093 -0.00754307 19.3051 0.0212288 19.4333C0.0426757 19.5286 0.101276 19.6652 0.151495 19.7366C0.201713 19.8082 0.291234 19.8967 0.350398 19.9333C0.409526 19.97 0.534228 20 0.627446 20C0.777997 20 1.72374 19.4878 9.09969 15.4112C13.6662 12.8874 17.4955 10.764 17.6092 10.6927C17.7438 10.6083 17.8481 10.5049 17.908 10.3964C17.9797 10.2666 18 10.1776 18 9.99341C18 9.81977 17.9783 9.71491 17.9183 9.59857C17.8733 9.51143 17.7706 9.39404 17.69 9.33775C17.6093 9.28141 13.7954 7.16141 9.21464 4.62657C1.53969 0.379603 0.869348 0.0166197 0.674636 0.00261016C0.543912 -0.00679988 0.42238 0.00961478 0.355927 0.0456936Z",
    fill: "#396AFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.981d1113c87ab2f56c66abd166955796.svg";
export { ForwardRef as ReactComponent };